import GamePlayer from "../components/UI/GamePlayer/GamePlayer";
import GameThumbnail from "../components/UI/GameThumbnail/GameThumbnail";
import PageWrapper from "./PageWrapper";

export default function ChickenPage() {
  document.title = "Flavy Softs - Mission Uncrossable"
  return (
    <PageWrapper>
      <GameThumbnail game="chicken" />
      <GamePlayer game="chicken" />
    </PageWrapper>
  );
}
